import type { CSSProperties, ReactNode } from 'react';
import { cardSurfaceStyle } from './cardSurface';

interface MokoCardProps {
  children: ReactNode;
  style?: CSSProperties;
  className?: string;
}

const MokoCard = ({ children, style, className }: MokoCardProps) => (
  <div className={className} style={{ ...cardSurfaceStyle, ...style }}>
    {children}
  </div>
);

export default MokoCard;
